{
  "advisor.confirmation": "Revisorbekreftelse",
  "advisor.confirmation.none.uploaded": "Ingen revisorbekreftelse er lastet opp",
  "back.to.reports": "Tilbake til Rapportering",
  "sivaAdmin": "SIVA-admin",
  "sivaAdmin.funds": "Tildelte midler",
  "sivaAdmin.confirmation": "Bekreftelse",
  "budget": "Budsjett",
  "budget.heading": "Budsjett og Revisorbekreftelse",
  "budget.none.uploaded": "Ingen budsjett er lastet opp",
  "budget.download": "Last ned budsjett",
  "budget.upload": "Last opp",
  "budget.upload.confirmation.text": "I budsjettår {{ year }} er denne filen lastet opp",
  "budget.upload.confirmation.text.fileName.changes": "Vi har endret filnavnet til",
  "budget.upload.deadline": "First for å laste opp",
  "budget.upload.error.description": "Noe gikk galt under opplasting av filen, vennligst prøv igjen.",
  "budget.upload.error.title": "Noe gikk galt!",
  "budget.year": "Budsjettår",
  "goals.updateAll": "Oppdater alle mål",
  "company.details.contract.addNewContract": "Legg til ny avtale",
  "company.details.contract.backToIdeasOrContracts": "Tilbake til alle ideer eller avtaler",
  "company.details.contract.changePhase": "Endre fase",
  "company.details.contract.changePhase.fromDate": "Ny fase gyldig fra*",
  "company.details.contract.revertPhase": "Angre faseendring",
  "company.details.contract.deleteContract": "Slett avtale",
  "company.details.contract.editContract": "Rediger",
  "company.details.contract.editContract.admissionNote": "Opptaksdato kan ikke endres. Dersom du trenger hjelp kontakt oss på",
  "company.details.contract.editContract.errormodal.header": "Beklager, vi kunne ikke oppdatere avtalen",
  "company.details.contract.editContract.successmodal.text": "Avtalen er oppdatert",
  "company.details.contract.revertContract.warning": "Denne handlingen tilbakestiller den siste registrerte faseendringen. Hvis relevant, fjernes også datoen for KTU- eller exitskjema.",
  "company.details.contract.revertContract.cantUndo": "Merk: Denne handlingen kan ikke gjøres om.",
  "company.details.contract.endContract": "Avslutt",
  "company.details.contract.endContract.error": "Beklager, vi kunne ikke avslutte avtalen",
  "company.details.contract.endContract.success": "Avtalen er avsluttet",
  "company.details.contract.overview.admissionDate": "Opptaksdato",
  "company.details.contract.overview.dispatchAdmissionForm": "Utsendelse av oppstartsskjema",
  "company.details.contract.overview.dispatchEnRouteForm": "Utsendelse av underveisskjema",
  "company.details.contract.overview.dispatchExitForm": "Utsendelse av exitskjema",
  "company.details.contract.overview.error.header": "Beklager, vi fant ikke avtalen",
  "company.details.contract.overview.error.text": "Prøv gjerne på nytt eller kontakt oss på",
  "company.details.contract.overview.exitDate": "Utgangsdato",
  "company.details.contract.overview.exitDate.required": "Velg en utgangsdato for denne bedriften",
  "company.details.contract.overview.id": "ID",
  "company.details.contract.overview.ideaName": "Idenavn",
  "company.details.contract.overview.ideaSource": "Idekilde",
  "company.details.contract.overview.ideaSource.none": "Ikke satt",
  "company.details.contract.overview.selfDeclaration": "Egenerklæring",
  "company.details.contract.overview.selfDeclarationValidTo": "Gyldig til: {{date}}",
  "company.details.contract.overview.ongoingContract": "Løpende avtale",
  "company.details.contract.overview.info": "Avtaleinformasjon",
  "company.details.contract.overview.contact": "Kontakt",
  "company.details.contract.overview.followUp": "Oppfølging",
  "company.details.contract.overview.dates": "Datoer",
  "company.details.contract.others.ingress": "Her finner du alle avtaler som er knyttet til denne bedriften.",
  "company.details.esa.bill.add": "Legg til faktura",
  "company.details.esa.bill.edit": "Rediger faktura",
  "company.details.esa.bill.delete": "Slett valgte",
  "company.details.esa.bill.noRegistered": "Ingen fakturaer er registrert",
  "company.details.esa.bill.notification.success": "Fakturaer registrert",
  "company.details.esa.bill.notification.generic": "ESA-rapportering kan ikke endres for angitt år",
  "company.details.esa.billedDeductible": "Fakturert egenandel",
  "company.details.esa.header": "ESA-rapport for",
  "company.details.esa.marketValue": "Markedsverdi",
  "company.details.esa.marketValueDeliveredServices": "Markedsverdi på leverte tjenester",
  "company.details.esa.summary": "Oppsummering",
  "company.details.esa.sumInnovationSupport": "Sum innovasjonsstøtte",
  "company.details.esa.sumReceivedInnovationSupport": "Sum mottatt innovasjonstøtte",
  "company.details.esa.supportIntensity": "Støtteintensitet",
  "company.details.esa.supportIntensityWarning": "Støtteintensitet overstiger 75%",
  "company.details.esa.supportIntensityWarningWithPhase": "Støtteintensitet overstiger 75% for bedriften i {{phase}}",
  "company.details.esa.total": "Total",
  "company.details.historic.ChangedFromTo": "Endret fra {{from}} til {{to}}",
  "company.details.historic.contractConcluded": "Avtalen er avsluttet",
  "company.details.historic.contractRestored": "Avtalen er gjenopprettet",
  "company.details.historic.ideaConcluded": "Idé er avsluttet",
  "company.details.historic.ideaRestored": "Idé er gjenopprettet",
  "company.details.historic.None": "Ingen historikk tilgjengelig.",
  "company.details.historic.Registered": "er registrert",
  "company.details.sidenav.contracts_one": "Avtale",
  "company.details.sidenav.contracts_other": "Andre avtaler",
  "company.details.sidenav.ESAReporting": "ESA-rapportering",
  "company.details.sidenav.GoalAchievement": "Resultater måltall",
  "company.details.sidenav.info": "Bedriftsinfo",
  "dataExtract": "Datauttrekk",
  "download.file.error": "Kunne ikke laste ned fil. Vennligst prøv igjen.",
  "error.acceptedDateAfterRegisteredDate": "Opptaksdato må være etter registreringsdato {{readableRegistrationDate}}",
  "error.support.message": "Prøv gjerne på nytt eller kontakt oss på",
  "esareport.details.phase.funds": "Artikkel 28",
  "esareport.details.phase.other": "Artikkel 28 Øvrige faser",
  "esareport.details.phase.preincubation": "Artikkel 28 Preinkubasjon",
  "esareport.details.ordinary": "Ordinær artikkel 28",
  "esareport.details.other": "Øvrig artikkel 28",
  "esareport.details.overviewAssignedFunds": "Oversikt over tildelte midler",
  "esareport.details.sumDisposable": "Sum disponibel artikkel 28, {{year}}",
  "esareport.details.topupFunding": "Toppfinansiering artikkel 28",
  "esareport.details.transferredFromLastYear": "Overført ubrukt artikkel 28 fra fjoråret",
  "esareport.details.adminstration": "Gjennomføring og administrasjon",
  "esareport.details.ordinaryAdmin": "Ordinær gjennomføring og administrasjon",
  "esareport.details.topupFundingAdmin": "Toppfinansering gjennomføring og administrasjon",
  "esareport.details.otherAdmin": "Øvrige gjennomføring og administrasjon",
  "esareport.details.sumDisposableAdmin": "Sum disponibel gjennomføring og administrasjon ",
  "esareport.phase.otherPhases": "øvrige faser",
  "esareport.phase.preincubation": "preinkubasjon",
  "esareport.summary": "Oppsummering artikkel 28",
  "esareport.summary.useOfArticle28": "Bruk av artikkel 28 i {{year}}",
  "esareport.summary.useOfArticle28WithPhase": "Bruk av artikkel 28 i {{phase}} {{year}}",
  "export.goalAccomplishment.header": "Eksporter måloppnåelse",
  "export.goalAccomplishment.exportButton": "Eksporter måloppnåelse for",
  "export.ideasAndCompanies.header": "Eksporter idéer og bedrifter",
  "export.ideasAndCompanies.exportButton": "Last ned totalrapport",
  "export.ideasAndCompanies.yearLabel": "Totalrapport for",
  "export.ktu.exportButton": "Last ned KTU-rapport",
  "export.ktu.header": "Kundetilfredshetsundersøkelse (KTU)",
  "export.reportingYear": "Rapportår",
  "reporting.status.closeYear": "Lukk rapportår",
  "reporting.status.openYear": "Åpne rapportår",
  "reporting.status.closedToast": "Lukket {{year}} for {{actorCount}} aktører.",
  "reporting.status.openedToast": "Åpnet {{year}} for {{actorCount}} aktører.",
  "reporting.status.error": "Noe gikk galt. Oppdater siden for å se status.",
  "extract.targetNumber.exportButton": "Eksporter excel måltallsuttrekk for",
  "extract.targetNumber.header": "Måltall uttrekkstabell",
  "file.none.choosen": "Ingen filtype er valgt",
  "file.type": "Filtype",
  "file.type.plural": "Filtyper",
  "files": "Filer",
  "hide.previous.files": "Skjul tidligere filer",
  "idea.mainContact": "Hovedkontakt",
  "idea.name": "Idénavn*",
  "idea.edit": "Rediger idé",
  "idea.edit.dialog.error.title": "Beklager, vi kunne ikke redigere idéen",
  "idea.edit.dialog.error.description": "Prøv gjerne på nytt eller kontakt oss på ",
  "idea.edit.dialog.backButton": "Tilbake til idé",
  "idea.edit.dialog.confirmation": "Idéen er redigert.",
  "idea.edit.error": "Noe gikk galt ved redigering av idé. Vennligst prøv igjen.",
  "ideaSource.industri": "Industri",
  "ideaSource.Import": "Import",
  "ideaSource.øvrig-næringsliv": "Øvrig næringsliv",
  "ideaSource.fou": "FoU (universitet, høgskoler, forskningsinstitutt)",
  "ideaSource.selvstendig-grunder": "Selvstendig gründer(e)",
  "ideaSource.annet": "Annet",
  "networkLogo": "Nettverkslogo",
  "notification.siva.summary.report": "Siva har gitt dere tilbakemeldinger på måltall {{ year }}.",
  "notification.siva.summary.report.url": "Se kommentarer",
  "search.Operatorname": "Søk etter operatørnavn",
  "show.previous.files": "Vis tidligere filer",
  "type.choose": "Velg type",
  "upload.files": "Last opp filer",
  "upload.file": "Last opp fil",
  "upload.file.drag": "eller dra den hit",
  "report.deadline": "Frist for å registere",
  "report.goals": "Måltall",
  "report.goals.positive": "Positiv endring",
  "report.goals.negative": "Negativ endring",
  "report.goals.unchanged": "Uendret måltall",
  "report.goals.difference.higher": "Ny verdi er høyere med +{{difference}}",
  "report.goals.difference.higherPercentage": "Ny verdi er høyere med +{{difference}} prosentpoeng",
  "report.goals.difference.lower": "Ny verdi er lavere med {{difference}}",
  "report.goals.difference.lowerPercentage": "Ny verdi er lavere med {{difference}} prosentpoeng",
  "report.goals.difference.unchanged": "Ny verdi er lik den forrige",
  "report.goalsAndBudget": "Rapporting av måltall og budsjett",
  "report.goals.eu.negative": "Vesentlig negativ",
  "report.goals.eu.positive": "Vesentlig positiv",
  "report.goals.eu.none": "Ingen",
  "report.goals.export.potensiale": "Nei, men har eksportpotensiale",
  "report.goals.export.underleverandor": "Nei, men er underleverandør til eksportbedrift",
  "targetNumber": "Måltall",
  "siva.offseasonHeadline": "Ny rapporteringsløsning er på vei",
  "siva.offseasonIntro1": "Vi jobber iterativt med å utvikle funksjonaliteter til ny rapporteringsløsning",
  "siva.offseasonIntro2": "Dersom du vil gi oss tilbakemelding på eksisterende eller kommende funksjonaliteter skriv gjerne til oss på <1>{{email}}</1>",
  "notification.siva.summary.approved": "Siva har godkjent deres måltall for {{ year }}",
  "notification.siva.summary.approved.url": "Se måltall {{ year }}",
  "ideasAndCompanies.title": "Idéer og bedrifter",
  "ideasAndCompanies.notFound": "Ingen idéer eller bedrifter er registrert",
  "add.idea": "Legg til idé",
  "add.company": "Legg til",
  "add.ideaOrCompany": "Legg til idé eller bedrift",
  "add.idea.error": "Noe gikk galt ved opprettelse av idé. Vennligst prøv igjen.",
  "add.company.error": "Noe gikk galt ved opprettelse av bedrift. Vennligst prøv igjen.",
  "phase.Idea": "Idé",
  "phase.PreIncubation": "Preinkubasjon",
  "phase.Incubated": "Inkubatorbedrift",
  "phase.Fi": "Forr.messig innovasjon",
  "phase.ScaleUp": "Skalering",
  "phase.Alumni": "Alumni",
  "phase.Targeted": "Målbedrift",
  "phase.OtherPhases": "Øvrige faser",
  "choose.phase": "Alle faser",
  "changePhase.success.text": "Fase er forandret fra",
  "changePhase.error.title": "Beklager, vi kunne ikke endre fase",
  "changePhase.error.text": "Prøv gjerne på nytt eller kontakt oss om feilen vedvarer",
  "changePhase.selfDeclaration.error.title": "Beklager, vi kunne ikke lagre egenerklæringen",
  "changePhase.selfDeclaration.error.text": "Faseendringen ble lagret, men lagring av egenerklæring feilet. Prøv igjen eller kontakt oss om feilen vedvarer",
  "idea.description": "Idébeskrivelse",
  "newIdeaForm.fromDate.label": "Registreringsdato*",
  "newIdeaForm.fromDate.required": "Velg en registreringsdato for idéen",
  "newIdeaForm.name.label": "Idénavn*",
  "newIdeaForm.name.required": "Skriv gjerne en kort beskrivelse av idéen",
  "newIdeaForm.ideaSource.label": "Idekilde*",
  "newIdeaForm.ideaSource.required": "Velg hvilken kilde idéen kommer fra",
  "newIdeaForm.ideaSource.helpText": "Vennligst angi hvor idéen kommer fra",
  "newIdeaForm.contactFirstName.label": "Fornavn*",
  "newIdeaForm.contactFirstName.required": "Skriv fornavnet til idéhaveren",
  "newIdeaForm.contactLastName.label": "Etternavn*",
  "newIdeaForm.contactLastName.required": "Skriv etternanvet til idéhaveren",
  "newIdeaForm.contactEmail.label": "E-post*",
  "newIdeaForm.contactEmail.required": "Skriv e-postadressen til idéhaveren",
  "newIdeaForm.contactEmail.validateEmail": "Skriv inn en gyldig e-postadresse til idéhaveren",
  "newIdeaForm.advisorId.label": "Rådgiver*",
  "newIdeaForm.advisorId.required": "Velg en rådgiver som skal følge opp idéen",
  "newIdeaForm.notes.label": "Notat (valgfritt)",
  "newIdeaForm.notes.maxLength": "Notat kan maksimalt være 1000 tegn",
  "newIdeaForm.section.title.contact": "Kontakt",
  "newIdeaForm.section.subTitle.contact": "Kontaktinformasjonen til idéhaver",
  "newIdeaForm.section.title.followUp": "Oppfølging",
  "newIdeaDialog.title.confirmation": "Bekreftelse",
  "newIdeaDialog.title.error": "Beklager, vi kunne ikke legge til idéen",
  "newIdeaDialog.error.text": "Prøv gjerne på nytt, eller kontakt oss på <1>{{ value }}</1>",
  "newIdeaDialog.error.buttonText": "Prøv på nytt",
  "newIdeaDialog.buttons.addNew": "Legg til ny idé",
  "newIdeaDialog.buttons.closeAndGoBack": "Lukk og gå tilbake til oversikt",
  "newIdeaDialog.text": "Idéen er lagt til.",
  "newCompany.baseInfoBox.orgNo": "Org nr.:",
  "newCompany.baseInfoBox.address": "Adresse:",
  "newCompany.baseInfoBox.noAddress": "Fant ingen adresse",
  "newCompany.brregSearch.title": "Søk i Brønnøysundregistrene",
  "newCompany.brregSearch.description": "Vi samler nøkkelopplysninger om registrerte virksomheter fra Brønnøysundregistrene. Bruk bedriftens navn eller organisasjonsnummer for å hente informasjon.",
  "newCompany.brregSearch.search.label": "Søk i Brønnøysundsregistrene",
  "newCompany.buttons.complete": "Fullfør og legg til bedrift",
  "newCompany.buttons.next": "Neste",
  "newCompany.buttons.previous": "Forrige",
  "newCompany.buttons.goBack": "Tilbake",
  "newCompany.buttons.cancel": "Avbryt",
  "newCompany.buttons.cancel.dialog.text": "Er du sikker på at du vil avbryte opprettelsen av bedriften? Innskrevet data vil ikke bli lagret.",
  "newCompany.buttons.cancel.dialog.buttons.cancel.text": "Avbryt, og gå til oversikt",
  "newCompany.buttons.cancel.dialog.buttons.continue.text": "Fortsett å opprette bedrift",
  "newCompany.buttons.cancel.dialog.title": "Avbryt opprettelse av bedrift",
  "newCompany.contract.title": "Fyll ut tilleggsinformasjon",
  "newCompany.contract.section.info.title": "Avtaleinformasjon",
  "newCompany.contract.form.name.label": "Idénavn",
  "newCompany.contract.form.name.description": "En kort beskrivelse av forretningsideen. Dette skal vises i bedriftsoversikten",
  "newCompany.contract.form.name.required": "Navn er påkrevd såfremt ingen bedrift er lagt til",
  "newCompany.contract.form.sivaPhase.label": "Fase*",
  "newCompany.contract.form.sivaPhase.required": "Velg hvilken fase denne bedriften (denne avtalen eller dette prosjektet) er i",
  "newCompany.contract.form.externalIndustry.label": "Bransje",
  "newCompany.contract.form.externalIndustry.helpText": "Vennligst angi hvilken bransje bedriften hører inn under. Dersom det er flere alternativer som kan være relevante, må du velge den bransjen du anser som hovedbransje. ​De ni første bransjene (fra Batteri til og med Sol) er innsatsområdene i Grønt industriløft.",
  "newCompany.contract.form.externalIndustry.required": "Vennligst angi hvilken bransje bedriften hører inn under.",
  "newCompany.contract.form.externalIndustry.placeholder": "Velg bransje...",
  "newCompany.contract.form.fromDate.label": "Opptaksdato",
  "newCompany.contract.form.fromDate.required": "Velg en dato for opptak av denne bedriften",
  "newCompany.contract.section.followUp.title": "Oppfølging",
  "newCompany.contract.form.advisorId.label": "Rådgiver*",
  "newCompany.contract.form.advisorId.required": "Velg en rådgiver som skal følge opp bedriften (denne avtalen eller dette prosjektet)",
  "newCompany.contract.form.notes.label": "Notat",
  "newCompany.contract.form.notes.label.description": "Notatet vil bli synlig i aktivitetsloggen",
  "newCompany.contract.form.notes.minLength": "Notat er påkrevd",
  "newCompany.contract.form.notes.maxLength": "Notat kan maksimalt være 1000 tegn",
  "newCompany.contract.form.ideaName.maxLength": "Idénavn kan maksimalt være {{value}} tegn. Bruk notatfeltet hvis du har behov for notater.",
  "newCompany.contract.form.formStartupDate.label": "Utsendelse av oppstartsskjema",
  "newCompany.contract.form.formMidDate.label": "Utsendelse av underveisskjema",
  "newCompany.contract.section.contact.title": "Kontakt",
  "newCompany.contract.section.contact.description": "Kontakten skal motta kundetilfredshetsundersøkelsen (KTU).",
  "newCompany.contract.form.contactFirstName.label": "Fornavn",
  "newCompany.contract.form.contactFirstName.required": "Skriv fornavnet til kontaktpersonen",
  "newCompany.contract.form.contactLastName.label": "Etternavn",
  "newCompany.contract.form.contactLastName.required": "Skriv etternavnet til kontaktpersonen",
  "newCompany.contract.form.contactEmail.label": "E-post",
  "newCompany.contract.form.contactEmail.required": "Skriv e-postadressen til kontaktpersonen",
  "newCompany.contract.form.contactEmail.validateEmail": "Skriv inn en gyldig e-postadresse til kontaktpersonen",
  "newCompany.contract.form.municipality.label": "Kommune",
  "newCompany.contract.form.ideaSource.label": "Idékilde",
  "newCompany.contract.form.ideaSource.required": "Idékilde er påkrevd for idéer",
  "newCompany.contract.form.ideaSource.placeholder": "Velg idékilde...",
  "newCompany.contract.form.registrationDate.label": "Registreringsdato",
  "newCompany.contract.form.errors": "Det er én eller flere feil i skjemaet. Sjekk at du har skrevet inn alle felter korrekt og prøv igjen.",
  "newCompany.contract.section.women.title": "Kvinner i bedriften",
  "newCompany.title.businessGarden": "Opptak til Næringshageprogrammet",
  "newCompany.title.incubator": "Opptak til Inkubatorprogrammet ",
  "newCompany.dialog.title.confirmation": "Bekreftelse",
  "newCompany.dialog.title.error": "Noe gikk galt under opprettelse av bedrift",
  "newCompany.dialog.buttons.goBack.text": "Tilbake til der jeg slapp",
  "newCompany.dialog.buttons.cancel.text": "Avbryt",
  "newCompany.dialog.buttons.addNew.text": "Legg til ny bedrift",
  "newCompany.dialog.buttons.closeAndGoBack.text": "Lukk og gå tilbake til oversikt",
  "newCompany.dialog.text.confirmation": "Bedriften <1>{{ value }}</1> ble lagt til.",
  "newCompany.dialog.text.error": "{{ value }} har <1>ikke</1> blitt lagt til.",
  "newCompany.dialog.text.created": "Avtale opprettet",
  "newCompany.info.title": "Innhent bedriftsinformasjon",
  "newCompany.info.description": "Vi har samlet nøkkelopplysninger om bedriften fra Brønnøysundregistrene. Vennligst sjekk at informasjonen er korrekt.",
  "newCompany.info.error.text1": "Kunne ikke hente informasjon om bedriften, vennligst gå tilbake og prøv på nytt!",
  "newCompany.info.error.text2": "Vedvarer problemet, ta kontakt med support, og meld inn saken med oppgitt organisasjon du prøvde å finne.",
  "newCompany.info.error.link.text": "Gå tilbake til oversikt",
  "newCompany.info.loadingText": "Henter data om bedriften ...",
  "companyTabs.about.nace.warning": "Vær oppmerksom på foretak med NACE-kode i 94-serien",
  "no.ceo": "Ingen daglig leder",
  "companyTabs.economy.title": "Regnskapstall for sist tilgjengelig år ({{ value }})",
  "companyTabs.economy.salesIncome": "Omsetning",
  "companyTabs.economy.balance": "Balanse",
  "companyTabs.economy.valueCreation": "Verdiskapning",
  "companyTabs.economy.operationalResults": "Driftsresultat",
  "companyTabs.economy.salaryExpenses": "Lønnskostnader",
  "companyTabs.economy.enterpriseStatus": "Foretaksstatus",
  "companyTabs.economy.notification.text1": "Kunne ikke finne regnskapsdata for <1>{{ name }}</1> ({{ orgNo }}).",
  "companyTabs.economy.notification.text2": "Det kan hende det ikke finnes noe regnskapsdata for denne bedriften enda.",
  "companyTabs.economy.loading.text": "Henter regnskapsdata ...",
  "companyTabs.tabs.about": "Om bedriften",
  "companyTabs.tabs.register": "Registre",
  "companyTabs.tabs.economy": "Regnskap",
  "companyTabs.tabs.applications": "Tidligere søknader",
  "companyTabs.error.loadingFailed": "Kunne ikke laste bedriftsinfo. Kontakt support om feilen vedvarer.",
  "companyTabs.applications.table.title": "Tidligere bevilgninger og søknader",
  "enterpriseStatus.active": "Aktiv",
  "enterpriseStatus.bankrupt": "Konkurs",
  "enterpriseStatus.underLiquidation": "Under avvikling",
  "enterpriseStatus.underCompulsoryLiquidationOrDissolution": "Under tvangsavvikling eller tvangsoppløsning",
  "companyTabs.about.notification.text1": "Kunne ikke finne bedriftsinfo for <1>{{ name }}</1>.",
  "companyTabs.about.notification.text2": "Det kan hende det ikke finnes bedriftsinformasjon for denne bedriften enda.",
  "companyTabs.about.registeredDate": "Registreringsdato",
  "newCompany.contract.form.fromDate.sameYear": "Kan kun velge en dato i innværende år.",
  "newCompany.contract.form.fromDate.openReportingYear": "Kan kun velge en dato i et åpent rapportår.",
  "newCompany.contract.form.advisorId.link.text": "Finner ikke rådgiver? Du kan legge til ansatte i",
  "choose.advisor": "Alle rådgivere",
  "overviewTabs.ideas": "Alle idéer",
  "overviewTabs.contracts": "Alle bedrifter",
  "overviewTabs.targetCompanies": "Alle målbedrifter",
  "overviewTabs.alumni": "Alle alumni",
  "overviewTabs.esaReporting": "ESA-rapportering",
  "phase.select": "Velg fase",
  "choose.industry": "Alle Bransjer",
  "contract.edit.connectCompany": "Knytt til bedrift",
  "contract.edit.noCompany.text": "Har ikke org. nummer enda. Vil legge til bedrift med org. nummer senere.",
  "contract.edit.noCompany.ariaLabel": "Ingen bedrift med org. nummer, skal legge til senere.",
  "reporting.selfdeclaration": "Egenerklæring",
  "reporting.selfdeclaration.classification": "Selvklassifisering",
  "reporting.selfdeclaration.Title": "Har du innhentet egenerklæring?",
  "reporting.selfdeclaration.dialog.title": "Registrer oppdatert egenerklæring",
  "reporting.selfdeclaration.deliveredDate": "Innsendt dato",
  "reporting.selfdeclaration.registerUpdatedQuestion": "Det finnes allerede en egenerklæring for denne avtalen. Vil du registrere en oppdatert en?",
  "reporting.selfdeclaration.registerUpdatedConfirm": "Registrer oppdatert",
  "reporting.selfdeclaration.Required": " Du må ha innhentet egenerklæring for å registrere en bedrift",
  "reporting.selfdeclaration.Associated": "Tilknyttet virksomhet",
  "reporting.selfdeclaration.Independent": "Uavhengig virksomhet",
  "reporting.selfdeclaration.Partner": "Partnervirksomhet",
  "goalAccomplishment.Total.YearError": "Kan ikke oppdatere total måloppnåelse for tidligere år",
  "ideasAndCompanies.terminateChosenIdeas": "Avslutt valgte idéer",
  "ideasAndCompanies.wantToTerminate": "Vil du avslutte",
  "ideasAndCompanies.chosenIdeasSingular": "valgt idé? Denne vil bli avsluttet med umiddelbar virkning.",
  "ideasAndCompanies.chosenIdeasPlural": "valgte idéer? Disse vil bli avsluttet med umiddelbar virkning.",
  "ideasAndCompanies.terminate": "Avslutt idéer",
  "ideasAndCompanies.reopenChosenIdeasCompanies": "Gjenåpne valgte idéer/bedrifter",
  "ideasAndCompanies.wantToReopen": "Vil du gjenåpne",
  "ideasAndCompanies.chosenIdeasCompaniesSingular": "valgt idé/bedrift?",
  "ideasAndCompanies.chosenIdeasCompaniesPlural": "valgte idéer/bedrifter?",
  "ideasAndCompanies.reopenChosen": "Gjenåpne valgte",
  "ideasAndCompanies.reopenIdeasCompanies": "Gjenåpne idéer/bedrifter",
  "ideasAndCompanies.generalErrorMessage": "Det har oppstått en feil. Vennligst prøv på nytt senere. Dersom feilen vedvarer, kontakt oss.",
  "ideasAndCompanies.generalErrorHeader": "Feilmelding",
  "ideasAndCompanies.ideasTerminatedPlural.header": "{{ count }} idéer er avsluttet",
  "ideasAndCompanies.ideasTerminatedPlural.text": "Idéene er flyttet til fanen Alle alumni og kan gjenåpnes derfra.",
  "ideasAndCompanies.ideasTerminatedSingular.header": "{{ count }} idé er avsluttet",
  "ideasAndCompanies.ideasTerminatedSingular.text": "Idéen er flyttet til fanen Alle alumni og kan gjenåpnes derfra.",
  "ideasAndCompanies.ideasCompaniesReopenedPlural": "{{ count }} inaktive idéer/bedrifter er gjenåpnet",
  "ideasAndCompanies.ideasCompaniesReopenedSingular": "{{ count }} inaktiv idé/bedrift er gjenåpnet",
  "goalAccomplishment.edited": "Redigert måloppnåelse",
  "ideasAndCompanies.reportingDone.header": "Årsrapportering {{ year }}",
  "ideasAndCompanies.reportingDone.text": "Marker som ferdig når du har fullført rapporteringen for {{ year }}.",
  "ideasAndCompanies.reportingDone.desc": "I Hjelp og brukerstøtte på sidepanelet til høyre kan du lese mer om hvordan årsrapportering fungerer i Flerbedriftsportalen.",
  "ideasAndCompanies.reportingDone.finished": "Ferdig",
  "ideasAndCompanies.reportingDone.notFinished": "Ikke ferdig",
  "ideasAndCompanies.goalsAndBudget.header": "Rapportering av måltall og budsjett {{ year }}",
  "ideasAndCompanies.resultsMetrics.header": "Resultater måltall",
  "ideasAndCompanies.changesAreAutomatic.text": "Endringene er automatisk lagret kl.",
  "ideasAndCompanies.reportingYearIsClosed.text": "Dette rapporteringsåret er lukket, og kan ikke redigeres. Kontakt Siva om du behøver å korrigere måloppnåelse.",
  "ideasAndCompanies.editResults.buttonText": "Rediger resultater",
  "ideasAndCompanies.exitEditing.buttonText": "Avslutt redigering",
  "ideasAndCompanies.internationalMarketOptionPositive.text": "Ja",
  "ideasAndCompanies.internationalMarketOptionNegative.text": "Nei",
  "ideasAndCompanies.internationalMarketOptionPotential.text": "Nei, men har internasjonalt markedspotensiale",
  "hasOnlyBeenIdea": "Har kun vært idé?",
  "ideasAndCompanies.delete.confirm": "Er du sikker på at du vil slette {{ contract }}?",
  "admittedToProgram": "Tatt opp i program",
  "ideaConsidered": "Idé vurdert",
  "programAdmission.title": "Opptak til program",
  "programAdmission.cannotAdmit.title": "Kan ikke ta opp henvendelse",
  "programAdmission.cannotAdmit.text": "For å ta opp til et program må du først tilknytte en bedrift.",
  "programAdmission.connectCompany": "Tilknytt bedrift",
  "programAdmission.addedToast": "{{name}} med fase {{phase}} ble lagt til.",
  "programAdmission.noAvailablePhases.businessGarden": "{{name}} har allerede en avtale. Kun én avtale kan registreres per bedrift.",
  "programAdmission.noAvailablePhases.incubator": "{{name}} har allerede en avtale i en annen fase enn {{phase}}. Kun én fase kan registreres per bedrift unntatt {{phase}}."
}
